// utils/base62.js
import baseX from 'base-x';

const BASE62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
const base62 = baseX(BASE62);

// ENCODE: Convert string to base62
export const encodeId = (str) => {
  const bytes = new TextEncoder().encode(str);
  return base62.encode(bytes); // Do NOT slice
};

// DECODE: Convert base62 back to original string
export const decodeId = (encoded) => {
  try {
    const bytes = base62.decode(encoded);
    return new TextDecoder().decode(bytes);
  } catch (err) {
    console.error('Decoding failed:', err);
    return null;
  }
};
